/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LevelInputs */

const en_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const es_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const fr_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const ja_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レベル`)
};

const zh_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`级别`)
};

const ar_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستوى`)
};

const id_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat`)
};

const it_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

const ru_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень`)
};

const pt_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const ko_field_level = /** @type {(inputs: Field_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레벨`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Field_LevelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_level = /** @type {((inputs?: Field_LevelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LevelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_level(inputs)
	if (locale === "es") return es_field_level(inputs)
	if (locale === "fr") return fr_field_level(inputs)
	if (locale === "de") return de_field_level(inputs)
	if (locale === "ja") return ja_field_level(inputs)
	if (locale === "zh") return zh_field_level(inputs)
	if (locale === "ar") return ar_field_level(inputs)
	if (locale === "id") return id_field_level(inputs)
	if (locale === "it") return it_field_level(inputs)
	if (locale === "ru") return ru_field_level(inputs)
	if (locale === "pt") return pt_field_level(inputs)
	return ko_field_level(inputs)
});